module.exports = __webpack_public_path__ + "static/circles-185701e52375dbc8cbd6627408574210.svg";